import { Navbar, NavItem } from "../components/Navbar";
import { useLoggedIn } from "../contexts/auth/LoggedInContext";

export function AdminLayout({ children }: { children: React.ReactNode }) {

    const { unreadMessages } = useLoggedIn();
    
    const navProps: NavItem[]  = [
        { name: "Upcoming Sessions", path: "/admin-upcoming-tutor-sessions" },
        { name: "Pending Payments", path: "/admin-pending-tutor-payments" },
        { name: "Messages", path: "/messages", notification: unreadMessages },
        { name: "Tutors", path: "/admin-tutors" },
        { name: "Functions", path: "/admin-functions" },
        { name: "Schools", path: "/admin-schools"},
        { name: "Requests", path: "/admin-requests" },
        { name: "Account", path: "/account" },
    ];

    return (    
        <>
            <Navbar navProps={navProps} showLocation={true} />
            {children}
        </>
    );
}